import Image from "next/image";
import { ReactNode, ComponentProps } from "react";
import { Card, Button } from "@filadd/phi-plus-core";
import { infoCardRecipe } from "./infoCardRecipe";

interface Action {
  label: string;
  buttonProps?: ComponentProps<typeof Button> &
    Omit<ComponentProps<"a">, "onClick">;
  closeAfter?: boolean;
}

interface InfoCardProps {
  imageUrl?: string;
  title?: string;
  description?: string;
  children?: ReactNode;
  actions?: Action[];
  footer?: ReactNode;
}

export const InfoCard = ({
  imageUrl,
  title,
  description,
  children,
  actions,
  footer,
}: InfoCardProps) => {
  const classes = infoCardRecipe();

  return (
    <Card.Root radius="lg" className={classes.root}>
      <Card.Header className={classes.header}>
        {imageUrl && (
          <Image
            src={imageUrl}
            alt="info"
            width={300}
            height={192}
            className={classes.image}
          />
        )}
        {title && <Card.Title className={classes.title}>{title}</Card.Title>}
        {description}
      </Card.Header>
      <Card.Body>
        {children}
        {actions != null ? (
          <div className={classes.actions}>
            {actions.map(
              ({ label, buttonProps: { href, ...buttonProps } = {} }) =>
                href ? (
                  <Button key={label} {...buttonProps} asChild>
                    <a href={href} target="_blank" rel="noreferrer">
                      {label}
                    </a>
                  </Button>
                ) : (
                  <Button
                    key={label}
                    {...buttonProps}
                    onClick={(e) => {
                      buttonProps?.onClick?.(e);
                    }}
                  >
                    {label}
                  </Button>
                ),
            )}
          </div>
        ) : null}
      </Card.Body>
      {footer && <Card.Footer>{footer}</Card.Footer>}
    </Card.Root>
  );
};
